import { Script } from "gatsby-script";
import React, { useEffect } from "react";

export default function JornayaScript() {
  useEffect(() => {
    if (document.getElementById("leadid_token")) {
      return;
    }
    // This <input> will be updated by Jornaya's script
    // and we definitely don't want react to try to mangle it
    const input = document.createElement("input");
    input.id = "leadid_token";
    input.type = "hidden";
    input.name = "universal_leadid";
    input.value = "";
    document.body.appendChild(input);
  }, []);
  return (
    <Script id="LeadiDscript">
      {`(function() {
var s = document.createElement('script');
s.id = 'LeadiDscript_campaign';
s.type = 'text/javascript';
s.async = true;
s.src = '//create.lidstatic.com/campaign/e212e27b-34fa-66b7-f180-1b5e812bd86a.js?snippet_version=2';
var LeadiDscript = document.getElementById('LeadiDscript');
LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
})();
`}
    </Script>
  );
}
